import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { ResponseUnidadEducativaModel, UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import Swal from 'sweetalert2';
import { NewPmeComponent } from '../../new-pme.component';
import { NewPlanMejoraService } from 'src/app/service/newPlanMejora.service';
import { NewFaseEstrategicaModel, ResponseNewFaseEstrategicaModel } from 'src/app/model/NewFaseEstrategica.model';

@Component({
  selector: 'app-pme-fase-estrategica',
  templateUrl: './pme-fase-estrategica.component.html',
  styleUrls: ['./pme-fase-estrategica.component.css']
})
export class PmeFaseEstrategicaComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;
  @Input() simulacion: boolean;
  cargando: boolean;
  cambios: boolean;
  dataJardin = new JardinModel();
  faseEstrategicaData = new NewFaseEstrategicaModel();
  uniEducativa = new UnidadEducativaModel(); 
  click = false;



  constructor(
    @Inject(NewPmeComponent) private parent: NewPmeComponent,
    private api: apiService,
    private newPlanMejoraService: NewPlanMejoraService
    ) {}

  ngOnInit(): void {     
    this.click = false;
    this.cargando = true;
    this.cambios = false;
    this.cargaInicial();
  }

  change() {
    this.cambios = true;
  }
  
  cargaInicial(){
    this.dataJardin = this.api.dataJardin;
    this.unidadEducativa(this.dataJardin);
    this.getFaseEstrategica(this.dataJardin);

  }

  formatObjetivos(objetivos:string){
    objetivos = objetivos.replace(/\.\s/g, '.<br>');
    return objetivos;

  }

  getPeriodoJardin(periodo){
    let periodoString = "2021"
    if(periodo == "Alternativo"){
      periodoString = "2024-2027"
    }else{
      periodoString = "2024-2027"
    }
    return periodoString
  }

  unidadEducativa(dataJardin:JardinModel){
      this.api.API_POST_obtenerUnidadEducatica(dataJardin.id).subscribe((response: ResponseUnidadEducativaModel) => {
        this.uniEducativa = response.payload;  
      },
      (err) => {
        console.log(err)
      });      
  }

  getFaseEstrategica(dataJardin:JardinModel){
    this.newPlanMejoraService.API_GET_getFaseEstrategica(dataJardin.idJardinPeriodo).subscribe((response:ResponseNewFaseEstrategicaModel) => {
      this.faseEstrategicaData = response.payload;  
      this.cargando = false;
      this.divSpinner.nativeElement.style.display='none';
    },
    (err) => {
      console.log(err)
    });      
  }

  guardarFaseEstrategica(){
    if (this.click == false) {
      Swal.fire({
        title: "Loading...",
        html: "Guardando Avances"
      });
      Swal.showLoading();

      this.click = true;
      this.newPlanMejoraService.API_POST_guardarFaseEstrategica(this.dataJardin.idJardinPeriodo,this.faseEstrategicaData).subscribe((response:any) => {
        this.cambios = false;
        this.ngOnInit();
        Swal.fire({
          title: 'Realizado!',
          text: 'Guardado con éxito',
          icon: 'info',
          confirmButtonText: 'OK',
          didClose: () => {
            Swal.hideLoading();
            }
        })
      },
      (err) => {
        console.log(err)
      });   
    }
   }

  validarFinalizar(){
    let errores = [];
    Swal.fire({
      title: 'Este proceso no se puede deshacer, ¿Desea continuar?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        
        errores = this.validarSubdimensiones();
        
        if (errores.length > 0) {
          Swal.fire({
            title: 'Faltan campos',
            text: errores[0],
            icon: 'error',
            confirmButtonText: 'OK'
          })
        } else {
          this.finalizarFaseEstrategica();
        }
      }
    })
  }


  

  validarSubdimensiones() : String[]{
    let errores = [];
    var numPriorizadaDimension = 0;
    this.faseEstrategicaData.dimensiones.forEach(dimension => {
      var numPriorizadaSubDimension = 0;

      dimension.subdimensiones.forEach(subdimension => {
        if(subdimension.priorizada){
          numPriorizadaSubDimension++
        }
      });

        if(numPriorizadaSubDimension>0){
          numPriorizadaDimension++
        }

        
        if(this.dataJardin.tipoJardin === 'Clásico'){
                  
          if(numPriorizadaSubDimension === 0){
            errores.push("Debe tener al menos una subdimensión priorizada por cada dimensión");
            return errores;
          }
        }

      });


      if(this.dataJardin.tipoJardin !== 'Clásico' && numPriorizadaDimension<3){
        errores.push("Debe tener al menos 3 dimensiones con priorizacion");
        return errores;
      }

    /*this.faseEstrategicaData.dimensiones.forEach(dimension => {
      dimension.subdimensiones.forEach(subdimension => {
        if(subdimension.priorizada){
          if(subdimension.objetivo === "" || subdimension.meta1 === "" || subdimension.meta2 === "" || subdimension.meta3 === "" || subdimension.meta4 === ""){
            errores.push("Debe completar todos los campos de la subdimension priorizada");
          }
        }
      });
    });*/


    this.faseEstrategicaData.dimensiones.forEach(dimension => {
      dimension.subdimensiones.forEach(subdimension => {
        if(subdimension.priorizada){
          if(subdimension.objetivo === "" || subdimension.meta3 === "" ){
            errores.push("Debe completar todos los campos de la subdimension priorizada");
          }
        }
      });
    });


    return errores;
  }


  finalizarFaseEstrategica(){
    Swal.fire({
      title: "Loading...",
      html: "Finalizando"
    });
    Swal.showLoading();
    
    this.newPlanMejoraService.API_POST_finalizarFaseEstrategica(this.dataJardin.idJardinPeriodo,this.faseEstrategicaData).subscribe((response:any) => {
      this.irAFinalizar();
    },
    (err) => {
      console.log(err)
    });  
  }

  irA(){
    this.parent.ngOnInit();
    this.parent.componente="";
  }

  irAFinalizar(){
    Swal.fire({
      title: 'Fase estratégica finalizada con éxito',
      icon: 'success',
      confirmButtonText: 'OK'
    }).then(() => {
      //this.parent.menuVisible("planmejora");
      this.irA();
    })
  }

  volver(){
    if (this.cambios == true){
      Swal.fire({
        title: 'Tiene cambios sin guardar, ¿desea continuar?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.irA();
        } 
      })
    }else {
      this.irA();
    } 
  }


}
